module.exports = __webpack_public_path__ + "img/white.887bd39b.png";